// Regex to check if the processed content contains any potential LaTeX patterns
const /** Is contain latex */ containsLatexRegex = /\\\(.*?\\\)|\\\[.*?\\\]|\$.*?\$|\\begin\{equation\}.*?\\end\{equation\}/;
// Regex for inline and block LaTeX expressions
const inlineLatex = new RegExp(/\\\((.+?)\\\)/, 'g');
const blockLatex = new RegExp(/\\\[(.*?[^\\])\\\]/, 'gs');
// Function to restore code blocks
const restoreCodeBlocks = function (content, codeBlocks) {
    return content.replace(/<<CODE_BLOCK_(\d+)>>/g, (match, index) => codeBlocks[index]);
};
// Regex to identify code blocks and inline code
const codeBlockRegex = /(```[\s\S]*?```|`.*?`)/g;
/**
 * Process LateX
 * @param _content The input string containing LaTeX expressions.
 */
const processLaTeX = function (_content) {
    let content = _content;
    // Temporarily replace code blocks and inline code with placeholders
    const codeBlocks = [];
    let index = 0;
    content = content.replace(codeBlockRegex, (match) => {
        codeBlocks[index] = match;
        return `<<CODE_BLOCK_${index++}>>`;
    });
    // Escape dollar signs followed by a digit or space and digit
    let processedContent = content.replace(/(\$)(?=\s?\d)/g, '\\$');
    // If no LaTeX patterns are found, restore code blocks and return the processed content
    if (!containsLatexRegex.test(processedContent)) {
        return restoreCodeBlocks(processedContent, codeBlocks);
    }
    // Convert LaTeX expressions to a markdown compatible format
    processedContent = processedContent
        .replace(inlineLatex, (match, equation) => `$${equation}$`) // Convert inline LaTeX
        .replace(blockLatex, (match, equation) => `$$${equation}$$`); // Convert block LaTeX
    // Restore code blocks
    return restoreCodeBlocks(processedContent, codeBlocks);
};
/**
 * Escape brackets
 * @param text The input string containing LaTeX expressions.
 */
const escapeBrackets = function (text) {
    const pattern = /(```[\S\s]*?```|`.*?`)|\\\[([\S\s]*?[^\\])\\]|\\\((.*?)\\\)/g;
    return text.replace(pattern, (match, codeBlock, squareBracket, roundBracket) => {
        if (codeBlock != null) {
            return codeBlock;
        }
        else if (squareBracket != null) {
            return `$$${squareBracket}$$`;
        }
        else if (roundBracket != null) {
            return `$${roundBracket}$`;
        }
        return match;
    });
};
const escapeMhchem = function (text) {
    return text.replaceAll('$\\ce{', '$\\\\ce{').replaceAll('$\\pu{', '$\\\\pu{');
};
/**
* Preprocesses LaTeX content by replacing delimiters and escaping certain characters.
* @param content The input string containing LaTeX expressions.
* @returns The processed string with replaced delimiters and escaped characters.
*/
const preprocessLaTeX = function (content) {
    // Step 1: Protect code blocks
    const codeBlocks = [];
    content = content.replace(/(```[\s\S]*?```|`[^`\n]+`)/g, (match, code) => {
        codeBlocks.push(code);
        return `<<CODE_BLOCK_${codeBlocks.length - 1}>>`;
    });
    // Step 2: Protect existing LaTeX expressions
    const latexExpressions = [];
    content = content.replace(/(\$\$[\s\S]*?\$\$|\\\[[\s\S]*?\\\]|\\\(.*?\\\))/g, (match) => {
        latexExpressions.push(match);
        return `<<LATEX_${latexExpressions.length - 1}>>`;
    });
    // Step 3: Escape dollar signs that are likely currency indicators
    content = content.replace(/\$(?=\d)/g, '\\$');
    // Step 4: Restore LaTeX expressions
    content = content.replace(/<<LATEX_(\d+)>>/g, (_, index) => latexExpressions[parseInt(index)]);
    // Step 5: Restore code blocks
    content = content.replace(/<<CODE_BLOCK_(\d+)>>/g, (_, index) => codeBlocks[parseInt(index)]);
    // Step 6: Apply additional escaping functions
    content = escapeBrackets(content);
    content = escapeMhchem(content);
    return content;
};
export { preprocessLaTeX, };
